// In-memory access token store. Nothing here touches localStorage.
let accessToken = null;
let sessionExpiredHandler = null;
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn(accessToken));

export const getAccessToken = () => accessToken;

export const setAccessToken = (token) => {
  accessToken = token;
  emit();
};

export const clearAccessToken = () => {
  accessToken = null;
  emit();
};

export const subscribeToken = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const setSessionExpiredHandler = (fn) => {
  sessionExpiredHandler = fn;
};

export const notifySessionExpired = () => sessionExpiredHandler?.();

